// extracted by mini-css-extract-plugin
module.exports = {"trustPilotWidget":"CartPageAside_trustPilotWidget__RBply","mgmWrapper":"CartPageAside_mgmWrapper___X6x9"};